<script>
  import { blurOnClick } from '../../../../../../js/blurOnClick';
  import { trackLinkClick } from '../../../../../../js/trackLinkClick';

  export let id;
  export let title;
  export let url;
  export let isSelected = false;
  export let isDynamicVariation = false;
</script>

<a
  {id}
  href={url}
  class:isSelected
  class:isDynamicVariation
  class="CtaSubnavDesktopNavLink"
  use:blurOnClick
  use:trackLinkClick={{ id, title, url }}
>
  <span>{title}</span>
</a>

<style>@charset "UTF-8";
.CtaSubnavDesktopNavLink {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  color: var(--color-gray, #737373);
  font-weight: var(--font-weight-medium, 500);
}
.CtaSubnavDesktopNavLink:focus {
  outline: none;
}
.CtaSubnavDesktopNavLink::-moz-focus-inner {
  border: 0;
}
.CtaSubnavDesktopNavLink:focus {
  outline: none;
}
.CtaSubnavDesktopNavLink::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.CtaSubnavDesktopNavLink:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.CtaSubnavDesktopNavLink > * {
  position: relative;
}
.CtaSubnavDesktopNavLink:hover {
  color: var(--color-text, #1a1a1a);
}
.CtaSubnavDesktopNavLink.isDynamicVariation {
  padding: 21px 10px;
}

.isSelected {
  color: var(--color-text, #1a1a1a);
}
.isSelected.isDynamicVariation {
  background-image: linear-gradient(var(--color-text), var(--color-text));
  background-position: calc(100% - 10px) 100%;
  background-size: calc(100% - 20px) 2px;
  background-repeat: no-repeat;
}</style>
